const getUserFacingLocation = (eventLocationDetails, defaultValue) => {
	// Return default value if input is invalid
	if (!eventLocationDetails || typeof eventLocationDetails !== 'object') {
		return defaultValue;
	}

	const { address = {}, resultType, localityType, title } = eventLocationDetails;

	// Initialize with title as fallback
	let eventLocationString = title;

	// Format based on result type
	if (resultType === 'houseNumber') {
		// House number format: "123 Main St"
		eventLocationString = `${address.houseNumber} ${address.street}`;
	} else if (resultType === 'locality') {
		// Handle locality types with different formats
		if (localityType === 'district') {
			eventLocationString = address.district;
		} else if (localityType === 'postalCode') {
			eventLocationString = `${address.postalCode}, ${address.city}, ${address.stateCode}`;
		} else if (localityType === 'city') {
			eventLocationString = `${address.city}, ${address.stateCode}`;
		}
		// If localityType doesn't match any known types, keep the default title
	} else if (resultType === 'street') {
		// Street only format: "Main St"
		eventLocationString = address.street;
	} else if (resultType === 'intersection') {
		// Intersection format: "Main St & Broadway" or fallback to title
		eventLocationString = address.streets?.join(' & ') || title;
	} else {
		// Default case - For unknown result types
		// Add house number and street if available
		if (address.houseNumber || address.street) {
			eventLocationString += ',';

			if (address.houseNumber) {
				eventLocationString += ` ${address.houseNumber}`;
			}

			if (address.street) {
				eventLocationString += ` ${address.street}`;
			}
		}
	}

	// Add city and state if available and appropriate
	if (resultType !== 'locality' && address.city && address.stateCode) {
		eventLocationString += `, ${address.city}, ${address.stateCode}`;
	}

	// Ensure we have a string to return
	return eventLocationString ?? title;
};

function initializeEventLocationAddressOrVenue() {
	const eventLocationAutocompleteInput = this.currentStepElement.querySelector('.js-event-location-input');
	const eventLocationAutocompleteDetails = this.currentStepElement.querySelector('#location-details');
	const eventLocationAutocompletePostalCode = this.currentStepElement.querySelector('#location-postal-code');
	const eventLocationAutocompleteFullAddress = this.currentStepElement.querySelector('#location-full-address');

	if (eventLocationAutocompleteInput) {
		const eventLocationAutocompleteCity = this.currentStepElement.querySelector('#event-location-city');

		const parent = this;
		let hereEventLocationDetails;

		$('#quote-request-event-location').autocompleteLocation({
			disableResultInputPopulation: true,
			allowCities: true,
			allowStates: true,
			resultDetailsLoaded: function(eventLocationDetails) {
				const userFacingLocation = getUserFacingLocation(eventLocationDetails, eventLocationAutocompleteInput.value);
				eventLocationAutocompleteInput.value = userFacingLocation;

				// Handle edge case caused by use of jQuery's `data()` helper from
				// inside jquery.autocompleteLocation.js in the `.blur()` handler
				// to restore altered input back to selected input. Since we're
				// customizing the user-facing input string above we also need to
				// update that value inside jQuery's data, which doesn't use the
				// native dataset property.
				$(eventLocationAutocompleteInput).data('selected-location-name', userFacingLocation);

				eventLocationAutocompleteCity.value = `${eventLocationDetails.address.city}, ${eventLocationDetails.address.stateCode}`;
				eventLocationAutocompletePostalCode.value = eventLocationDetails.address.postalCode;
				parent.clearErrors();
				hereEventLocationDetails = eventLocationDetails;

				let fullAddress = hereEventLocationDetails.address.label;
				fullAddress = fullAddress.replace(new RegExp('(-[0-9]{4})?, (United States)$', 'i'), '');
				fullAddress = fullAddress.replace(new RegExp(', Puerto Rico, Puerto Rico$', 'i'), ', Puerto Rico');
				fullAddress = fullAddress.replace(new RegExp(', Puerto Rico(( [0-9]{5})(-[0-9]{4})?)?$', 'i'), ', PR$2');
				fullAddress = fullAddress.replace(new RegExp(', Canada$', 'i'), '');

				eventLocationAutocompleteFullAddress.value = fullAddress;

				eventLocationDetails.user_input = fullAddress;
				eventLocationAutocompleteDetails.value = JSON.stringify(eventLocationDetails);
			},
			resultCleared: function() {
				hereEventLocationDetails = null;
			}
		});
	}
}

export {
	initializeEventLocationAddressOrVenue
}
